export const USER = 'user';
export const USER_DATA_KEY = 'user-data';
export const SEARCH_USER_DATA_KEY = '@pwa:search-user-data';
